import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Number4 = (props: Icon): React.ReactElement => (
  <svg
    style={{ ...style(props.size, props.height), ...props.style }}
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <path
        d="M12,3.99999995 C7.58172197,3.99999995 3.99999995,7.58172197 3.99999995,12 C3.99999995,16.418278 7.58172197,20 12,20 C16.418278,20 20,16.418278 20,12 C20,7.58172197 16.418278,3.99999995 12,3.99999995 Z M12,5.33333329 C15.6818984,5.33333329 18.6666667,8.31810165 18.6666667,12 C18.6666667,15.6818984 15.6818984,18.6666667 12,18.6666667 C8.31810165,18.6666667 5.33333329,15.6818984 5.33333329,12 C5.33333329,8.31810165 8.31810165,5.33333329 12,5.33333329 Z M14.1616211,16 L14.1616211,14.3725586 L15.1069336,14.3725586 L15.1069336,13.0834961 L14.1616211,13.0834961 L14.1616211,8.14746094 L12.6308594,8.14746094 L9.18798828,13.2177734 L9.18798828,14.3725586 L12.5395508,14.3725586 L12.5395508,16 L14.1616211,16 Z M12.5395508,13.0834961 L10.6489258,13.0834961 L12.0883789,10.9082031 C12.2745768,10.6289062 12.4339193,10.3424479 12.5664062,10.0488281 L12.5664062,10.0488281 L12.609375,10.0488281 C12.5986328,10.116862 12.5843099,10.3621419 12.5664062,10.784668 C12.5485026,11.207194 12.5395508,11.5294596 12.5395508,11.7514648 L12.5395508,11.7514648 L12.5395508,13.0834961 Z"
        id="path-1-number-5"
      ></path>
    </defs>
    <g
      id="Project-EOT"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Atom/icon/numbers/four-circle/line">
        <mask id="mask-2-number-5" fill="white">
          <use xlinkHref="#path-1-number-5"></use>
        </mask>
        <use
          id="Combined-Shape"
          fill="#FFFFFF"
          fillRule="nonzero"
          xlinkHref="#path-1-number-5"
        ></use>
        <g
          id="Group"
          mask="url(#mask-2-number-5)"
          fill={props.color || theme.palette.grey600}
        >
          <g id="🎨-color">
            <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
